<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout class="table--first-row" row wrap>
          <v-flex class="table__wrapper--center">
            <v-icon
              class="table__btn--blue"
              v-show="selectedRow"
              @click="openInvestmentCard"
              >note</v-icon
            >
            <p class="caption" v-show="selectedRow" @click="openInvestmentCard">
              OTWÓRZ KARTĘ
            </p>
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout row wrap>
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
              class="table__btn--blue"
              >cloud_download</v-icon
            >
            <p
              class="caption"
              @click="
                'pobierz' in $refs && $refs.pobierz.showExportMenu($event)
              "
            >
              POBIERZ REJESTR
            </p>
            <v-icon
              class="table__btn--padding table__btn--red"
              v-show="selectedRow"
              @click="deleteRow('/technical_preconditions')"
              >delete</v-icon
            >
            <p
              class="caption"
              v-show="selectedRow"
              @click="deleteRow('/technical_preconditions')"
            >
              USUŃ
            </p>
          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex xs5 class="table__wrapper--center table__wrapper--filter">
        <v-layout align-right justify-end>
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>
    <ag-grid-vue
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      style="height: 90%"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    filter: "",
    numberAll: "0", //hint z textfielda wymaga, by wartość była typu string
    numberFiltered: "0", //hint z textfielda wymaga, by wartość była typu string
    selectedRow: undefined,
    statusFilter: "",
    tableTitle: "techPreconditionsTable"
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api
        .getModel()
        .rootNode.childrenAfterFilter.length.toString();
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        onSelectionChanged: this.onSelectionChanged,
        rowSelection: "single",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    }
  },
  beforeMount() {
    const formatDate = function(date, time) {
      if (date.value) {
        let options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        };
        if (time) {
          options.hour = "2-digit";
          options.minute = "2-digit";
        }
        return new Date(date.value).toLocaleString("pl-PL", options);
      } else {
        return null;
      }
    };
    //Funkcja porównująca daty (splitujemy string, tworzymy obiekt daty, która leci do porównania)
    const compareDate = function(filterLocalDateAtMidnight, cellValue) {
      if (!cellValue) return 0;
      let date = new Date(cellValue);
      let [dateString, timeString] = cellValue.split("T");
      var dateStringParts = dateString.split("-");
      // let timeStringParts = timeString.split(':')
      var day = Number(dateStringParts[2]);
      var month = Number(dateStringParts[1]) - 1;
      var year = Number(dateStringParts[0]);
      // TODO spróbować naprawić godziny i minuty
      // let hours = Number(timeStringParts[0])
      // let minutes = Number(timeStringParts[1])
      var cellDate = new Date(year, month, day);
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      } else if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      } else {
        return 0;
      }
    };

    this.columnDefs = [
      { headerName: "Numer pisma", field: "document_number" },
      {
        headerName: "Data przyjęcia",
        field: "document_date",
        cellRenderer: date => formatDate(date),
        filter: "agDateColumnFilter",
        filterParams: {
          comparator: (filterLocalDateAtMidnight, cellValue) =>
            compareDate(filterLocalDateAtMidnight, cellValue),
          browserDatePicker: true
        }
      },
      { headerName: "Lokalizacja w archiwum", field: "archive_localization" },
      { headerName: "Numer działki", field: "address_parcel" },
      { headerName: "Obręb", field: "address_precinct" },
      { headerName: "Miejscowość", field: "address_place" },
      { headerName: "Ulica", field: "address_street" },
      { headerName: "Numer domu", field: "address_order" },
      { headerName: "Status inwestycji", field: "status" },
      { headerName: "Opis inwestycji", field: "description" }
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api
        .getModel()
        .rootNode.childrenAfterFilter.length.toString();
    },
    deleteRow(featureName) {
      let payload = {
        oid: this.selectedRow.investment,
        feature: featureName
      };
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie warunku technicznego",
        text: "Czy na pewno chcesz usunąć warunek techniczny?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store
                .dispatch("removeInvestmentFeature", payload)
                .then(r => {
                  if (!r) {
                    this.$root.$emit("showSnackbar", "red", `${r}`);
                    return;
                  }
                  this.loadData();
                });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    openInvestmentCard() {
      if (this.activeModals.includes("investmentCardModal")) {
        this.$modal.hide("investmentCardModal");
      }
      this.$store
        .dispatch("getSingleInvestment", this.selectedRow.investment)
        .then(r => {
          this.show("investmentCardModal");
          this.$root.$emit("loadTab", 2);
          this.$root.$emit("loadInvestment", r);
        });
    },
    loadData() {
      this.$store.dispatch("getTechPreconditions").then(r => {
        this.numberAll = r.technical_preconditions.length;
        this.numberFiltered = this.numberAll;
        this.gridOptions.api.setRowData(r.technical_preconditions);
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if (localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if (columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/investments/TechnicalPreconditionsTable.vue